import {
  REPORTS_MODULE,
  VIEW_REPORTS,
  DOWNLOAD_REPORTS,
} from 'utils/roles/permissions/reportsPermissions';
import { REPORTS_LIST_PATH } from 'utils/roles/paths';

export function reportsAuth(permissions) {
  const allowedModules = [];


    allowedModules.push(REPORTS_MODULE);


  return allowedModules;
}

export function reportsPathsAuth(permissions) {
  const allowedPaths = [];

    allowedPaths.push(REPORTS_LIST_PATH);


  return allowedPaths;
}
